import { PrjSaveMessage } from './../dialogs/project-save-dialog/project-save-entry.component';
import { SimpleHandler, TypedHandler } from './../../types/handlers';
import { ConfigAttribute, AttributeInputType, Preset } from 'app/types/project-config';
import { AttributeListingSelection } from './attribute-listing/attribute-listing.component';
import { ProjectConfig, AttributeFeatureType } from './../../types/project-config';
import { ProjectSaveDialogService } from './../dialogs/project-save-dialog/project-save-dialog.service';
import { ProjectLoadDialogService } from './../dialogs/project-load-dialog/project-load-dialog.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectConfigUtil } from 'app/model/project-config-util';
import { Project } from 'app/model/project';
export type ProjectCfgTopView = 'workspaces' | 'left-view';

@Component({
  selector: 'app-project-config',
  templateUrl: './project-config.component.html',
  styleUrls: ['./project-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectConfigComponent implements OnInit {

  public topView: ProjectCfgTopView = 'workspaces';
  public workspaceView: string = 'general';
  public subSelectorView: string = '';
  public leftView = 'selectors';

  private _projectConfig?: ProjectConfig;
  public set projectConfig(cfg: ProjectConfig | undefined) {
    this._projectConfig = cfg;
    this.Refresh();
  }
  public get projectConfig(): ProjectConfig | undefined {
    if (!this._projectConfig) {
      if (this._project && this._project.config) {
        return this._project.config;
      }
    }
    return this._projectConfig;
  }
  private _project?: Project;
  @Input()
  public set project(prj: Project | undefined) {
    if (!prj) return;
    this.SetViews('top');
    this._project = undefined;
    this.Refresh();
    this._project = prj;

    if (!!this._project) {
      if (this._ready) {
        this.cdr.markForCheck();
        this._projectConfig = this._project.config;

      }
      this.Refresh();
      this.SetViews('general');
    }
  }
  public get project(): Project | undefined {
    return this._project;
  }
  private _updateHandler?: TypedHandler<PrjSaveMessage>;
  @Input()
  public set updateHandler(handler: TypedHandler<PrjSaveMessage> | undefined) {
    this._updateHandler = handler;
  }
  public projectChange = new EventEmitter<Project>();
  public selectedAttribute?: ConfigAttribute;
  public selectedAttributeType?: AttributeFeatureType;
  public selectedPreset?: Preset;
  public lastUpdate = new Date();
  private _ready = false;
  @Output() onClose = new EventEmitter<void>();
  constructor(private cdr: ChangeDetectorRef,
    private projectLoader: ProjectLoadDialogService,
    private projectSaver: ProjectSaveDialogService) {
    this.projectConfig = ProjectConfigUtil.MakeEmptyConfig();
    // this.project = new Project();
    // this.project.SetProjectConfig(this.projectConfig);
  }
  Refresh() {
    if (!!this._ready) {
      this.cdr.detectChanges();
    }
  }
  ngOnInit(): void {
    this._ready = true;
    this.Refresh();
  }
  ShowSelectors() {
    this.SetViews('top');
  }
  HandleWSButton(target?: EventTarget | null) {
    if (!target) return;
    this.SetViews((target as HTMLButtonElement).dataset.view as string);
  }
  SetViews(viewName?: string) {
    if (!viewName) return;
    switch (viewName) {
      case 'top':
        this.topView = 'left-view';
        this.workspaceView = '';
        this.subSelectorView = '';
        this.leftView = 'selectors';
        break;
      case 'general':
        this.topView = 'workspaces';
        this.workspaceView = 'general';
        this.subSelectorView = '';
        this.leftView = 'selectors';
        break;
      case 'attributes':
        this.topView = 'left-view';
        this.subSelectorView = 'attributes';
        this.leftView = 'sub-selectors';
        break;
      case 'presets':
        this.topView = 'left-view';
        this.subSelectorView = 'presets';
        this.leftView = 'sub-selectors';
        break;
      case 'supplementals':
        this.topView = 'left-view';
        this.subSelectorView = 'supplementals';
        this.leftView = 'sub-selectors';
        break;
    }
    this.Refresh();
  }
  SaveProject() {
    if (!this._project) {
      return;
    }
    this.projectSaver.Show({
      config: this._project.config as ProjectConfig,
      handler: (message: PrjSaveMessage) => {
        if (this._updateHandler) {
          this._updateHandler(message);
        }
        console.log('saved');
      },
      project_id: this._project.projectId
    });
  }
  LoadProject() {
    const projectConfig = ProjectConfigUtil.MakeEmptyConfig();
    this.projectLoader.Show({
      handler: (project: Project) => {
        this.project?.Merge(project);
        console.log('config loaded');
        this.Refresh();
      },
      project: this.project
    });
  }
  Debug() {
    console.log(this.projectConfig);
  }
  ShowAttribute(selection: AttributeListingSelection) {
    console.log(selection);
    this.workspaceView = 'attributes';
    this.topView = 'workspaces';
    this.selectedAttribute = selection.attribute;
    this.selectedAttributeType = selection.type;
    this.Refresh();
  }
  AttributeUpdated(attr: ConfigAttribute) {
    this.lastUpdate = new Date();
    this.projectChange.emit(this.project);
    this.Refresh();
  }
  ShowPreset(preset: Preset) {
    this.workspaceView = 'preset';
    this.topView = 'workspaces';
    this.selectedPreset = preset;
    this.Refresh();
  }
  Close() {
    this.onClose.emit();
  }
}
